import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import { creator, errorMessageGenerator } from 'uwork-app-core';
import axios from 'utils/axios';

/**
 * Constants
 */
export const REQUEST = '@app/departmetns/all-skills/REQUEST';
export const SUCCESS = '@app/departmetns/all-skills/SUCCESS';
export const FAILURE = '@app/departmetns/all-skills/FAILURE';
export const CLEAR = '@app/departmetns/all-skills/CLEAR';

/**
 * Initial state
 */
const initState = {
    skills: [],
    loading: false,
    error: ''
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case REQUEST:
                draft.loading = true;
                draft.error = '';
                break;
            case SUCCESS:
                draft.loading = false;
                draft.skills = payload;
                break;
            case FAILURE:
                draft.loading = false;
                draft.error = '';
                break;
            case CLEAR:
                draft.loading = false;
                draft.error = '';
                draft.skills = [];
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    clear: () => creator(CLEAR)
};

/**
 * Sagas
 */
export const sagas = {
    *request() {
        try {
            const response = yield axios.get('/workers/skills?pagination=1');
            yield put(actions.success(response.data.data));
        } catch (e) {
            console.error(e);
            const error = errorMessageGenerator(e);
            yield put(actions.failure(error));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
